import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AvailabilityModule } from "../../sb-editor-tools/availability/availability.module";
import { BestnodeComponent } from "../../sb-editor-tools/bestnode/bestnode.component";
import { ColormapModule } from "../../sb-editor-tools/colormap/colormap.module";
import { MinimapComponent } from "../../sb-editor-tools/minimap/minimap.component";
import { PanningComponent } from "../../sb-editor-tools/panning/panning.component";
import { ZoomingComponent } from "../../sb-editor-tools/zooming/zooming.component";
import { LabelsComponent } from "../../sb-editor-tools/labels/labels.component";
import { LayersComponent } from "../../sb-editor-tools/layers/layers.component";
import { MapComponent } from "./map.component";


@NgModule({
    declarations: [
        MapComponent,
        MinimapComponent,
        PanningComponent,
        ZoomingComponent,
        BestnodeComponent,
        LabelsComponent,
        LayersComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ColormapModule,
        AvailabilityModule,
    ],
    providers: [],
    exports:[
        MapComponent
    ]
})
export class MapModule {}